import { render, staticRenderFns } from "./OpenProPage.vue?vue&type=template&id=6fd645d6"
import script from "./OpenProPage.vue?vue&type=script&lang=js"
export * from "./OpenProPage.vue?vue&type=script&lang=js"
import style0 from "./OpenProPage.vue?vue&type=style&index=0&id=6fd645d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports